module.exports = __webpack_public_path__ + "2f0afbdcdd55d9874737e66dfa606346.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thesafezone/informe.png
// module id = 336
// module chunks = 1